<div class="nested-menu">
    <ng-container *ngIf="items.length">
        <button type="button" mat-menu-item #trigger="matMenuTrigger" [matMenuTriggerFor]="tabledriven"
                id="filter-place-category"
                class="top-bar-font-size" [class.filtering]="isFiltering" (menuOpened)="menuOpened($event)">
            {{ title || 'FILTER BY CATEGORY' }}
            <mat-icon>chevron_left</mat-icon>
        </button>

        <mat-menu #tabledriven="matMenu" class="ig-nested-menu">
            <button type="button" mat-menu-item all (click)="select($event)">All</button>
            <ng-container *ngFor="let item of items">
                <ig-nested-menu-item [item]="item" [useNonLeafMenuClick]="useNonLeafMenuClick"
                                     (onClick)="select($event)"
                                     (onNonLeafClick)="nonLeafClick($event)"></ig-nested-menu-item>
            </ng-container>
        </mat-menu>
    </ng-container>

    <ng-container *ngIf="!items.length">
        <div class="top-bar-font-size wide-btn ig-according-header ellipsis" [class.filtering]="true">
            {{ title || 'FILTER BY CATEGORY' }}
        </div>
    </ng-container>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/nested.menu/nested.menu.component.html